import { render, staticRenderFns } from "./UploadToVersapay.vue?vue&type=template&id=9592aea0"
import script from "./UploadToVersapay.vue?vue&type=script&lang=js"
export * from "./UploadToVersapay.vue?vue&type=script&lang=js"
import style0 from "./UploadToVersapay.vue?vue&type=style&index=0&id=9592aea0&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports